// extracted by mini-css-extract-plugin
export default {"unseted_img":"BiggerImage_unseted_img__r20zs","lightbox":"BiggerImage_lightbox__dU6pE","show":"BiggerImage_show__IhJI5","show_image":"BiggerImage_show_image__JItD2"};